<template>
  <div id="app">
    <TheNavigation />
    <transition name="fade" mode="out-in">
      <router-view :key="$route.path" />
    </transition>
  </div>
</template>
<script>
import TheNavigation from "@/components/TheNavigation";

export default {
  components: {
    TheNavigation
  },

  meta() {
    return {
      title: "Portfólio Wagner Ramos",
      meta: {
        title: { name: "title", content: "Portfolio Wagner Ramos" },
        description: {
          name: "description",
          content:
            "Desenvolvedor Front-end, Apaixonado por Design, Programação e UX"
        },
        keywords: {
          name: "keywords",
          content:
            "Trabalhos Freelancers,consultorias,Vue JS,Nuxt JS,Quasar,UX,Astro JS,pixel perfect,design Thinking,desenvolvimento front-end,acessibilidade,usabilidade"
        },

        ogTitle: { name: "og:title", content: "Portfolio Wagner Ramos" },
        ogDescription: {
          name: "og:description",
          content:
            "Trabalhos Freelancers,consultorias,Vue JS,Nuxt JS,Quasar,UX,Astro JS,pixel perfect,design Thinking,desenvolvimento front-end,acessibilidade,usabilidade"
        },
        ogUrl: { name: "og:url", content: "http://www.wagneramos.com.br" },

        twTitle: { name: "twitter:title", content: "Portfolio Wagner Ramos" },
        twDescription: {
          name: "twitter:description",
          content:
            "Trabalhos Freelancers,consultorias,Vue JS,Nuxt JS,Quasar,UX,Astro JS,pixel perfect,design Thinking,desenvolvimento front-end,acessibilidade,usabilidade"
        },
        twUrl: { name: "twitter:url", content: "http://www.wagneramos.com.br" }
      },
      link: {
        canonical: { rel: "canonical", href: "http://www.wagneramos.com.br" }
      }
    };
  }
};
</script>
<style lang="scss">
@import "components/styles/_main.scss";
</style>
